(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 87314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(68294);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 98122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _buttons_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21489);




var ViewDealsButton = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        className: "flex items-center py-2",
        href: "/deals",
        passHref: true,
        legacyBehavior: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_buttons_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
            classes: "my-6",
            size: _buttons_Button__WEBPACK_IMPORTED_MODULE_3__/* .ButtonSize.primary */ .qE.primary,
            type: _buttons_Button__WEBPACK_IMPORTED_MODULE_3__/* .ButtonType.primary */ .L$.primary,
            children: "Explore Opportunities"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ViewDealsButton);


/***/ }),

/***/ 637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);



var SeoHead = function(param) {
    var title = param.title, description = param.description, imageURI = param.imageURI, pagePath = param.pagePath, twitterTitle = param.twitterTitle, twitterDescription = param.twitterDescription;
    var defaultDescription = description !== null && description !== void 0 ? description : "Most people don’t have the resources, time, or connections to truly use their web3 IP. Our goal at OverpassIP is to provide holders with easily accessible opportunities to leverage their NFTs IP. With OverpassIP, the web3 user will seamlessly connect with the Web2 brand. Join us in revolutionizing IP functionality for years to come.";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "shortcut icon",
                type: "image/svg+xml",
                href: "/overpass.svg"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: defaultDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: imageURI ? imageURI : "/img/OverPassCover.png"
            }, "ogimage"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }, "ogtitle"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: defaultDescription
            }, "ogdesc"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: pagePath !== null && pagePath !== void 0 ? pagePath : "/"
            }, "ogurl"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: "@OverpassIP"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:creator",
                content: "@OverpassIP"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: twitterTitle ? twitterTitle : title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: twitterDescription ? twitterDescription : defaultDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: imageURI ? imageURI : "/img/OverPassCover.png"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SeoHead);


/***/ }),

/***/ 7414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ usePageEntrance; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74682);
/* harmony import */ var _app_config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31470);
/* harmony import */ var _app_config_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_app_config_js__WEBPACK_IMPORTED_MODULE_1__);
/* eslint-disable */ 


var usePageEntrance = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), once = ref[0], setOnce = ref[1];
    var onceVar = false;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (once || onceVar) {
            return;
        }
        setOnce(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        onceVar = true;
        // @ts-ignore
        var timeline = new gsap__WEBPACK_IMPORTED_MODULE_2__/* .gsap.timeline */ .p8.timeline();
        var int = setInterval(function() {
            if ((_app_config_js__WEBPACK_IMPORTED_MODULE_1___default().transitionFinished)) {
                clearInterval(int);
                var enterEls = document.querySelectorAll(".enter-el, .enter-el-block, .enter-el-inherit");
                timeline.fromTo(enterEls, {
                    y: 40
                }, {
                    y: 0,
                    stagger: .07,
                    force3D: true,
                    duration: 1.4,
                    ease: "expo.out"
                }).fromTo(enterEls, {
                    opacity: 0
                }, {
                    opacity: 1,
                    stagger: .07,
                    force3D: true,
                    duration: 1.35,
                    ease: "expo.out"
                }, 0.05);
            }
        });
    });
};


/***/ }),

/***/ 68294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/head/SeoHead.tsx
var SeoHead = __webpack_require__(637);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./styles/Home.module.scss
var Home_module = __webpack_require__(35020);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
;// CONCATENATED MODULE: ./components/sections/landing/CardTrio.tsx
/* eslint-disable @next/next/no-img-element */ 




var HowItWorks = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((Home_module_default()).cardtrio, " container grid max-w-[983px] grid-cols-1 items-center gap-4 md:grid-cols-2 md:px-4"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Home_module_default()).cardblur
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "md:col-span-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((Home_module_default()).largecard, " ").concat((Home_module_default()).landingcard),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((Home_module_default()).cardbg, " desktop-only"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 1300,
                                height: 614,
                                quality: 100,
                                layout: "responsive",
                                src: "/img/home/large-card-bg.jpg"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((Home_module_default()).cardbg, " mobile-only"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 522,
                                height: 561,
                                quality: 100,
                                layout: "responsive",
                                src: "/img/home/small-card-bg.jpg"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((Home_module_default()).cardcontent, " flex flex-col items-center"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    className: "font-gt-haptik text-heading-4 font-bold md:text-heading-3 lg:text-heading-2",
                                    children: "Holders"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "max-w-[580px] text-center font-satoshi-med font-medium",
                                    children: "Maximize your NFT's potential with brand licensing. Gain recognition and influence by licensing your NFT to renowned brands."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        alt: "Three collectible digital characters displayed side by side: a penguin in green attire on red, a penguin with a brown hat on blue, and a yellow ape with a hat on purple.",
                                        src: "/img/home/holders.png",
                                        className: "ml-[35px] mt-[-20px] md:mt-[-40px]"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((Home_module_default()).smallcard, " ").concat((Home_module_default()).landingcard),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((Home_module_default()).cardbg),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 522,
                                height: 561,
                                quality: 100,
                                layout: "responsive",
                                src: "/img/home/small-card-bg.jpg"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((Home_module_default()).cardcontent, " flex flex-col items-center"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    className: "font-gt-haptik text-heading-4 font-bold md:text-heading-3 lg:text-heading-2",
                                    children: "Collections"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "max-w-[367px] text-center font-satoshi-med font-medium",
                                    children: "Each licensed NFT amplifies your collection's reach, providing you with more exposure and uniqueness to unlock unparalleled growth for your project."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        alt: "An illustrated penguin adorned with a floral lei framed in a purple, postage stamp-like border, complemented by a rising arrow and a checkmark badge on a dark purple background.",
                                        src: "/img/home/collections.png",
                                        className: "ml-[-32px] mt-[15px]"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((Home_module_default()).smallcard, " ").concat((Home_module_default()).landingcard),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((Home_module_default()).cardbg),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 522,
                                height: 561,
                                quality: 100,
                                layout: "responsive",
                                src: "/img/home/small-card-bg.jpg"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((Home_module_default()).cardcontent, " flex flex-col items-center"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    className: "font-gt-haptik text-heading-4 font-bold md:text-heading-3 lg:text-heading-2",
                                    children: "Brands"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "max-w-[367px] text-center font-satoshi-med font-medium",
                                    children: "Seamlessly partner with Web3 collections and acquire the perfect IP that aligns with your campaigns."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        alt: "Digital icons of popular NFT collections displayed above a glowing hexagonal platform: a Pudgy Penguin in a blue circle, a Pudgy Igloo in a purple circle, and the Bored Ape Yacht Club (BAYC) logo in a pink circle, set against a dark backdrop with a spotlight effect.",
                                        src: "/img/home/brands.png",
                                        className: "mt-[35px] md:mt-[15px]"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var CardTrio = (HowItWorks);

// EXTERNAL MODULE: ../../node_modules/gsap/index.js + 2 modules
var gsap = __webpack_require__(74682);
// EXTERNAL MODULE: ./constants/constants.ts
var constants = __webpack_require__(36630);
;// CONCATENATED MODULE: ./components/sections/landing/HeroVideo.tsx
/* eslint-disable */ 





var HeroVideo = function() {
    var playVid = // eslint-disable-next-line @typescript-eslint/no-unused-vars,no-unused-vars
    function playVid(event) {
        var ref;
        var playButton = document.getElementById("play-button");
        var playButtonGradient = playButton === null || playButton === void 0 ? void 0 : playButton.parentElement;
        var videoCover = playButtonGradient === null || playButtonGradient === void 0 ? void 0 : playButtonGradient.previousElementSibling;
        var video = playButtonGradient === null || playButtonGradient === void 0 ? void 0 : (ref = playButtonGradient.previousElementSibling) === null || ref === void 0 ? void 0 : ref.previousElementSibling;
        gsap/* default.to */.ZP.to([
            playButton,
            playButtonGradient,
            videoCover
        ], {
            autoAlpha: 0,
            ease: "sine.inOut",
            duration: 0.23
        });
        // @ts-ignore
        video.play();
        // @ts-ignore
        video.addEventListener("click", function() {
            // @ts-ignore
            if (video.paused) {
                // @ts-ignore
                video.play();
            } else {
                // @ts-ignore
                video.pause();
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((Home_module_default()).herovideo, " ").concat((Home_module_default()).c164, " max-w-[100vw]"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((Home_module_default()).videowrapper, " enter-el"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Home_module_default()).bgwrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        width: 1800,
                        height: 1209,
                        quality: 100,
                        className: (Home_module_default()).bg,
                        priority: true,
                        layout: "responsive",
                        src: "/img/home/vid-bg.jpg"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((Home_module_default()).framewrapper),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Home_module_default()).gradone
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Home_module_default()).gradtwo
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            quality: 100,
                            className: (Home_module_default()).frame,
                            layout: "fill",
                            src: "/img/home/vid-frame.png"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((Home_module_default()).coverwrapper),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                            preload: "true",
                            loop: true,
                            playsInline: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                src: "".concat(constants/* CLOUDFLARE_BUCKET_URL */.aQ, "/overpass.mp4")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            quality: 100,
                            className: (Home_module_default()).cover,
                            layout: "fill",
                            src: "/img/home/vid-cover.png"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Home_module_default()).playcover,
                            id: "play-gradient",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: (Home_module_default()).playbutton,
                                id: "play-button",
                                onClick: playVid,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        width: "123",
                                        height: "123",
                                        viewBox: "0 0 123 123",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                filter: "url(#filter0_b_3855_5426)",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                        cx: "61.5",
                                                        cy: "61.5",
                                                        r: "61.5",
                                                        fill: "white",
                                                        fillOpacity: "0.05"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                        cx: "61.5",
                                                        cy: "61.5",
                                                        r: "61",
                                                        stroke: "white",
                                                        strokeOpacity: "0.08"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M75.8937 61.4834L53.2129 48.8516V74.1494L75.8937 61.4834Z",
                                                fill: "#9DB4F0"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                                                    id: "filter0_b_3855_5426",
                                                    x: "-32",
                                                    y: "-32",
                                                    width: "187",
                                                    height: "187",
                                                    filterUnits: "userSpaceOnUse",
                                                    colorInterpolationFilters: "sRGB",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                                            floodOpacity: "0",
                                                            result: "BackgroundImageFix"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                                            in: "BackgroundImageFix",
                                                            stdDeviation: "16"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                                            in2: "SourceAlpha",
                                                            operator: "in",
                                                            result: "effect1_backgroundBlur_3855_5426"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                                            mode: "normal",
                                                            in: "SourceGraphic",
                                                            in2: "effect1_backgroundBlur_3855_5426",
                                                            result: "shape"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "".concat((Home_module_default()).dottedline)
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var landing_HeroVideo = (HeroVideo);

;// CONCATENATED MODULE: ./components/sections/landing/HowItWorks.tsx




var HowItWorks_HowItWorks = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((Home_module_default()).howitworks, " flex max-w-[100vw] justify-center"),
        "data-entrance": "stagger-fade",
        "data-offset": ".75",
        "data-mobile-offset": ".85",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container flex w-full flex-col",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "mb-5 text-center font-gt-haptik text-heading-4 font-bold md:text-heading-3 lg:text-heading-2",
                    children: "How It Works"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex w-full flex-col justify-between md:flex-row md:gap-20 md:px-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-14 flex flex-col items-center justify-center text-center md:mb-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((Home_module_default()).howicon),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        width: 254,
                                        height: 209,
                                        quality: 100,
                                        layout: "responsive",
                                        src: "/img/home/icon-how.png"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "font-satoshi-bold text-heading-6 font-bold",
                                    children: "Holders"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "font-satoshi-reg text-md",
                                    children: "Holders can submit their NFTs to be considered for licensing opportunities given by collections or brands."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-14 flex flex-col items-center justify-center text-center md:mb-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((Home_module_default()).howicon),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        width: 254,
                                        height: 209,
                                        quality: 100,
                                        layout: "responsive",
                                        src: "/img/home/icon-how.png"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "font-satoshi-bold text-heading-6 font-bold",
                                    children: "Collections"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "font-satoshi-reg text-md",
                                    children: "Collections being on Overpass allows endless opportunities for their brand to grow while bringing their holders with them, all through licensing."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-14 flex flex-col items-center justify-center text-center md:mb-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((Home_module_default()).howicon),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        width: 254,
                                        height: 209,
                                        quality: 100,
                                        layout: "responsive",
                                        src: "/img/home/icon-how.png"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "font-satoshi-bold text-heading-6 font-bold",
                                    children: "Brands"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "font-satoshi-reg text-md",
                                    children: "Brands can post licensing opportunities for collections, collect a pool of NFTs to choose from, and pick the IP that will best represent their initiative."
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var landing_HowItWorks = (HowItWorks_HowItWorks);

// EXTERNAL MODULE: ./components/UI/ViewDealsButton.tsx
var ViewDealsButton = __webpack_require__(98122);
;// CONCATENATED MODULE: ./components/sections/landing/LandingSection.tsx




var LandingSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((Home_module_default()).landingsection, " flex max-w-xl flex-col items-center text-center"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                    className: "".concat((Home_module_default()).heroHeader, " mb-2 font-gt-haptik font-bold md:text-heading-1"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "enter-el font-gt-haptik text-heading-4 font-bold md:text-heading-2 lg:text-heading-1",
                            children: "NFT Licensing"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "enter-el block font-gt-haptik text-heading-4 font-bold md:text-heading-2 lg:text-heading-1",
                            children: "Made Easy."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "enter-el mb-8 mt-4 text-lg font-medium md:text-heading-6",
                    children: "Maximize the potential of your NFT’s."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "enter-el",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewDealsButton/* default */.Z, {})
                })
            ]
        })
    });
};
/* harmony default export */ var landing_LandingSection = (LandingSection);

;// CONCATENATED MODULE: ./public/img/home/prefooter-grid.png
/* harmony default export */ var prefooter_grid = ({"src":"/_next/static/media/prefooter-grid.c9ca462c.png","height":617,"width":1380,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAABlBMVEW0tP/DzP/G2h9fAAAAAnRSTlMFHvHrBB4AAAAJcEhZcwAACxMAAAsTAQCanBgAAAAOSURBVHicY2DADRihAAAASAAJF/bDKgAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./components/sections/landing/PreFooter.tsx






var PreFooter = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((Home_module_default()).prefooter, " flex flex-col items-center bg-cover bg-center"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((Home_module_default()).prefooterGridWrapper),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: prefooter_grid,
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((Home_module_default()).prefooterGradient)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                className: "font-gt-haptik text-heading-5 font-bold text-accent-main md:text-heading-3 lg:text-heading-2",
                children: "Explore Opportunities"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "max-w-[414px] text-center text-lg",
                children: "Make NFT’s non-fungible again."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((Home_module_default()).buttonduo, " flex flex-row"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewDealsButton/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((Home_module_default()).cardmerch, " flex flex-row justify-between"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((Home_module_default()).assetcard),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            layout: "fill",
                            objectFit: "contain",
                            quality: 100,
                            src: "/img/home/landingCards/prefooter-card-1.png"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((Home_module_default()).assetcard, " ").concat((Home_module_default()).assetcardtwo),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            layout: "fill",
                            objectFit: "contain",
                            quality: 100,
                            src: "/img/home/landingCards/prefooter-card-2.png"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((Home_module_default()).assetcard),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            layout: "fill",
                            objectFit: "contain",
                            quality: 100,
                            src: "/img/home/landingCards/prefooter-card-3.png"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((Home_module_default()).assetmerch, " ").concat((Home_module_default()).assetmerchone),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            className: "merch merch-1",
                            layout: "fill",
                            objectFit: "contain",
                            quality: 100,
                            src: "/img/home/landingCards/prefooter-merch-1.png"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((Home_module_default()).assetmerch, " ").concat((Home_module_default()).assetmerchtwo),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            className: "merch merch-2",
                            layout: "fill",
                            objectFit: "contain",
                            quality: 100,
                            src: "/img/home/landingCards/prefooter-merch-2.png"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var landing_PreFooter = (PreFooter);

// EXTERNAL MODULE: ./hooks/usePageEntrance.ts
var usePageEntrance = __webpack_require__(7414);
;// CONCATENATED MODULE: ./pages/index.tsx
/* eslint-disable */ 








var Home = function() {
    (0,usePageEntrance/* usePageEntrance */.s)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoHead/* default */.Z, {
                title: "OverpassIP",
                imageURI: "/img/OverPassCover.png",
                description: "Imagine your NFT as toys, GIFs, collectibles, and more. With OverpassIP, you can maximize the potential of your NFTs. Access opportunities to license them to Web2 brands, earn ongoing royalties, and join us in revolutionizing IP monetization."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: (Home_module_default()).main,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_LandingSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_HeroVideo, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_HowItWorks, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTrio, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_PreFooter, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 35020:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__97eC3","c164":"Home_c164__zxycW","heroHeader":"Home_heroHeader__kl7nw","heroP":"Home_heroP__y0JZ8","main":"Home_main__OVLM4","landingsection":"Home_landingsection__zwJFp","herovideo":"Home_herovideo__j3rn5","videowrapper":"Home_videowrapper__MI8KK","coverwrapper":"Home_coverwrapper__DSFDZ","gradone":"Home_gradone__22lFW","gradtwo":"Home_gradtwo__S7SoB","playcover":"Home_playcover__c4MJh","playbutton":"Home_playbutton__pgdb1","dottedline":"Home_dottedline__6IsZQ","bgwrapper":"Home_bgwrapper__ycBvC","framewrapper":"Home_framewrapper__JQnrF","cover":"Home_cover__KDvzz","howitworks":"Home_howitworks___TN1N","howicon":"Home_howicon__74B5S","cardtrio":"Home_cardtrio__w9ccq","landingcard":"Home_landingcard__OAEY3","cardcontent":"Home_cardcontent__c0blM","cardbg":"Home_cardbg__YFjwb","largecard":"Home_largecard__6pWtn","smallcard":"Home_smallcard__TEYPo","cardblur":"Home_cardblur__628Q8","prefooter":"Home_prefooter__AQeeA","prefooterGridWrapper":"Home_prefooterGridWrapper__vvvWP","prefooterGradient":"Home_prefooterGradient__9nUkn","buttonduo":"Home_buttonduo__Hxy4w","footer":"Home_footer__zed0_","cardmerch":"Home_cardmerch__hlqx_","assetcard":"Home_assetcard__Abb85","assetcardtwo":"Home_assetcardtwo__hkpYC","assetmerch":"Home_assetmerch__RVYFL","assetmerchone":"Home_assetmerchone__FH7bY","assetmerchtwo":"Home_assetmerchtwo___RdSJ","grid":"Home_grid__npx0i","card":"Home_card__K7aTN","logo":"Home_logo__FLQOc","code":"Home_code__2i1pD"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(87314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);